var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c("div", { staticClass: "popup" }, [
      _c(
        "div",
        {
          staticClass: "popup_block",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "loader loader--style1",
              staticStyle: { "text-align": "center" },
              attrs: { title: "0" }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    version: "1.1",
                    id: "loader-1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    x: "0px",
                    y: "0px",
                    width: "100px",
                    height: "100px",
                    viewBox: "0 0 40 40",
                    "enable-background": "new 0 0 40 40",
                    "xml:space": "preserve"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      opacity: "0.2",
                      fill: "#000",
                      d:
                        "M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946\n                             s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634\n                             c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "path",
                    {
                      attrs: {
                        fill: "#000",
                        d:
                          "M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0\n                             C22.32,8.481,24.301,9.057,26.013,10.047z"
                      }
                    },
                    [
                      _c("animateTransform", {
                        attrs: {
                          attributeType: "xml",
                          attributeName: "transform",
                          type: "rotate",
                          from: "0 20 20",
                          to: "360 20 20",
                          dur: "0.5s",
                          repeatCount: "indefinite"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56f944a1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56f944a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/loader.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-56f944a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/modals/loader.vue
// module chunks = 0